import React from "react";
import ReactMarkdown from "react-markdown";

export default function HarmonizedDataset({
  harmonized_datasets_intro,
  harmonized_datasets,
}: {
  harmonized_datasets_intro?: string;
  harmonized_datasets?: string;
}) {
  let datasets: { name: string; desc: string; source: string; link: string }[] = [];
  try {
    if (harmonized_datasets) {
      const parsedData = JSON.parse(harmonized_datasets);
      datasets = parsedData.datasets || [];
    }
  } catch (error) {
    console.error("Failed to parse harmonized_datasets:", error);
  }

  return (
    <div className="tab-pane fade show active">
      {harmonized_datasets_intro && (
        <div className="g2-text-grey">
          <ReactMarkdown>{harmonized_datasets_intro}</ReactMarkdown>
        </div>
      )}

      {datasets && datasets.length > 0 ? (
        <table className="table table-hover table-striped" width="100%">
          <tbody>
            {datasets.map((dataset, index) => (
              <tr key={index}>
                <td className="text-end fw-bold" width="20%">
                  {dataset.name}
                </td>
                <td width="50%">
                  <ReactMarkdown>{dataset.desc}</ReactMarkdown>
                </td>
                <td width="30%">
                  <a href={dataset.link} target="_blank" className="g2-link-blue fw-bold text-decoration-none">
                    {dataset.source}
                    <i className="bi bi-box-arrow-up-right m-1"></i>
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="mt-3 g2-text-grey fst-italic">Coming soon</div>
      )}
    </div>
  );
}
